import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { ObjectFormatterObjectFieldEntity } from './object-formatter-object-field.entity';
import { ObjectEntity } from './object.entity';

@Index('unique-name', ['fkObjectId', 'name'], { unique: true })
@Index('unique-sort-order', ['fkObjectId', 'sortOrder'], { unique: true })
@Entity('_object_formatter')
export class ObjectFormatterEntity extends BaseEntity {
	@Column('int', { name: '_fk__object__id', nullable: true, unsigned: true })
	public fkObjectId!: number | null;

	@Column('varchar', { name: '_name', length: 255 })
	public name!: string;

	@Column('varchar', { name: '_type', length: 255 })
	public type!: string;

	@Column('smallint', { name: '_sortOrder', unsigned: true })
	public sortOrder!: number;

	@ManyToOne(() => ObjectEntity, (object) => object.objectFormatters, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__object__id', referencedColumnName: 'id' }])
	public fkObject!: ObjectEntity;

	@OneToMany(
		() => ObjectFormatterObjectFieldEntity,
		(objectFormatterObjectField) =>
			objectFormatterObjectField.fkObjectFormatter,
		{},
	)
	public objectFormatterObjectFields!: Array<ObjectFormatterObjectFieldEntity>;
}
